<ng-container *transloco="let t" class="container">
    <ng-template #errorBanner let-text="text" let-class="class">
        <div class="error-banner {{class}}">
            <i class="bi bi-exclamation-circle-fill fs-14"></i>
            <span>{{ text }}</span>
        </div>
    </ng-template>

    @let hasStartNumberError = !!timingDataResponse?.startNumberError;
    @let hasDuplicateChips = !!timingDataResponse?.duplicateChipNumbers?.length;
    @let showTeamMembersTable = !!teamMemberFields && !!competitor?.teamMembers;
    @let duplicateChipsText = hasDuplicateChips
    ? t('competitor.timing.error.DUPLICATE_CHIP_NUMBER') + ': ' + timingDataResponse!.duplicateChipNumbers!.join(', ')
    : '';

    <app-admin-modal-layout [title]="title ?? ''"
                            (onClose)="onCancel()"
                            (onSave)="onCompetitorSave()">
        <div class="border-shadow p-3 mb-2">
            <app-competitor-info [isTeam]="isTeamRace" [competitor]="competitor"/>
        </div>
        @if (inputForm) {
        @if (hasStartNumberError || (hasDuplicateChips && !showTeamMembersTable)) {
        <div class="d-flex flex-column gap-6 mb-2">
            @if (hasStartNumberError) {
                <ng-container *ngTemplateOutlet="errorBanner; context: { text: t('competitor.timing.error.' + timingDataResponse!.startNumberError!), class: 'full' }"></ng-container>
            }
            @if (hasDuplicateChips && !showTeamMembersTable) {
            <ng-container *ngTemplateOutlet="errorBanner; context: { text: duplicateChipsText, class: 'full' }"></ng-container>
            }
        </div>
        }
        <form [formGroup]="inputForm">
                <div class="border-shadow my-2 p-3">
                            <app-team-members-management-form [inputForm]="inputForm" [formHelper]="formHelper"/>
                </div>
        </form>
        }
        @if (showTeamMembersTable) {
        <ng-container [ngTemplateOutlet]="teamMembers"></ng-container>
        }

        @if (!editingTeamMemberId && showTeamMembersTable) {
        <div class="border-shadow d-flex flex-column mt-2 p-16">
            <div class="detail-col-title">{{ t('competitor.team.member.selected') }}</div>
            <div class="color-grey-neutral-400 fs-13">{{ t('competitor.team.member.select.prompt') }}</div>
        </div>
        }

        @if (editingTeamMemberId && activeTeamMemberForm) {
        <div class="border-shadow mt-2">
            <div class="d-flex justify-content-between align-items-start p-16 pb-1">
                <div>
                    <div class="detail-col-title">{{ t('competitor.team.member.selected') }}</div>
                    <div class="detail-col-desc">
                        {{ t('competitor.team.member.editing.for') }} <strong>{{ editingTeamMemberFullName }}</strong>
                    </div>
                </div>
                 <button type="button" class="btn-close fs-14" aria-label="Close" (click)="onTeamMemberEditClose()">
                 </button>
            </div>
            <div class="px-16 pb-16">
                <form [formGroup]="activeTeamMemberForm">
                    <app-team-members-management-form [inputForm]="activeTeamMemberForm" [formHelper]="activeTeamMemberFormHelper!"/>
                </form>
            </div>
        </div>
        }
        <div class="pt-5 mb-5"></div>
    </app-admin-modal-layout>

    <ng-template #teamMembers>
        <div class="border-shadow">
            @if (hasDuplicateChips && showTeamMembersTable) {
            <div class="d-flex flex-column gap-6 mb-2">
              <ng-container *ngTemplateOutlet="errorBanner; context:{ text: duplicateChipsText }"/>
            </div>
            }
            <div class="p-16 pb-1">
                <div class="detail-col-title">{{ t('competitor.team.members') }}</div>
                <div class="detail-col-desc">{{ t('competitor.team.members.description') }}</div>
            </div>
            <div class="table-container" horizontalScrollableTable>
                <table class="table">
                    <thead>
                    <tr>
                        @for (kv of (teamMemberFields?.options | keyvalue:keepOriginalOrder); track kv.key; let idx = $index) {
                        @if (kv.value.selected && kv.value.isGeneral) {
                        @if (kv.key === 'fullName' || kv.key === 'chipNumber') {
                        <th sticky [stickyWidth]="200">
                        {{t('competitor.table.' + kv.key)}}
                        </th>
                        }
                        @else {
                        <th scope="col" class="col-min-width-150">
                        {{t('competitor.table.' + kv.key)}}
                        </th>
                        }
                        }
                        }
                        @for (kv of (teamMemberFields?.options | keyvalue:keepOriginalOrder); track kv.key) {
                        @if (kv.value.selected && kv.value.isCustom) {
                        <th scope="col" class="col-min-width-150">
                            {{kv.value.label}}
                        </th>
                        }
                        }
                        @for (kv of (teamMemberFields?.options | keyvalue:keepOriginalOrder); track kv.key) {
                        @if (kv.value.selected && kv.value.isPricing) {
                        <th scope="col" class="col-min-width-200">
                            {{kv.value.label}}
                        </th>
                        }
                        }
                        <th sticky [stickyWidth]="60" [stickyRight]="true"></th>
                    </tr>
                    </thead>
                    <tbody>
                    @for (teamMember of teamMemberViewData; track teamMember.id) {
                    <tr [class.active]="teamMember.id === editingTeamMemberId"
                        [class.error]="invalidTeamMemberIds[teamMember.id!]">
                    @for (kv of (teamMemberFields?.options | keyvalue:keepOriginalOrder); track kv.key; let idx = $index) {
                    @if (kv.value.selected && kv.value.isGeneral) {
                    <ng-template #fieldTpl>
                        <span class="text-nowrap">
                                <app-competitor-field-output
                                [competitor]="teamMember"
                                [key]="kv.key"
                                [isAdmin]="true"
                                [fieldType]="'general'"
                                [showAsPlain]="false"
                                [showTooltip]="true"/>
                        </span>
                    </ng-template>
                     @if (kv.key === 'fullName' || kv.key === 'chipNumber') {
                    <td sticky [stickyWidth]="200">
                        @if (kv.key === 'fullName' && invalidTeamMemberIds[teamMember.id!]) {
                        <i class="bi bi-info-circle row-error-icon"></i>
                        }
                        <ng-container [ngTemplateOutlet]="fieldTpl"/>
                    </td>
                    } @else {
                    <td class="center-align">
                        <ng-container [ngTemplateOutlet]="fieldTpl"/>
                    </td>
                    }
                    }
                    }
                    @for (kv of (teamMemberFields?.options | keyvalue: keepOriginalOrder); track kv.key) {
                    @if (kv.value.selected && kv.value.isCustom) {
                    <td class="center-align">
                        <span class="text-nowrap">
                            <app-competitor-field-output
                                [competitor]="teamMember" [isAdmin]="true"
                                [key]="kv.key"
                                [showTooltip]="true"
                                [fieldType]="'custom'"/>
                        </span>
                    </td>
                    }
                    }
                    @for (kv of (teamMemberFields?.options | keyvalue:keepOriginalOrder); track kv.key) {
                    @if (kv.value.selected && kv.value.isPricing) {
                    <td class="center-align">
                        <span class="text-nowrap">
                            <app-competitor-field-output
                                [competitor]="teamMember" [isAdmin]="true"
                                [key]="kv.key"
                                [showTooltip]="true"
                                [fieldType]="'pricing'"/>
                        </span>
                    </td>
                    }
                    }
                    <td sticky [stickyWidth]="60" [stickyRight]="true">
                        <div class="d-flex align-items-center justify-content-center">
                            <div class="action-icon" (click)="onTeamMemberEdit(teamMember)">
                                <i class="bi bi-pencil-fill"></i>
                            </div>
                        </div>
                    </td>
                </tr>
                    }
                    </tbody>
                </table>
            </div>
        </div>
    </ng-template>
</ng-container>